module.exports = __webpack_public_path__ + "img/dadaocheng_pano-min.c652686e.jpg";